import { SafeArea } from './ui/safe-area.js';
import type { SafeAreaApi } from './ui/safe-area.js';
import { imageAttemptDeadlineMs } from './ui/image-attempt-deadline.js';

declare global {
  interface Window {
    MoonfallLandingSafeArea: SafeAreaApi;
    MoonfallLandingImageAttemptDeadline: (attempt?: number) => number;
  }
}

// The landing's inline interactions share the app's measured viewport insets.
window.MoonfallLandingSafeArea = SafeArea;
window.MoonfallLandingImageAttemptDeadline = imageAttemptDeadlineMs;
